__turbopack_context__.v({
  "icon": "Avx_dq_icon",
  "message": "Avx_dq_message",
});
